<div class="module-wrapper content-wrapper">
  <div class="tab-container">
    <mat-card>
      <mat-card-content>
        <div class="head-container">
          <div class="pageTitle">
            <h1>{{'itemDetails.heading' | translate}}</h1>

            <!-- <div (mouseover)="isHidden = true">
              <img class="trainingIcon" src="../../../assets/favicon/video.png">
            </div>

            <div class="popupHover">
              <ng-container *ngIf="isHidden">
                <div class="hideshow">
                  <a *ngFor="let links of videoLinks" (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', links.assetUrl);">{{links.assetShortName}} <br></a>
                </div>
              </ng-container>
            </div> -->
          </div>
          <div class="bread-crumb">
            <div class="breadcrumb-container">
              <a [routerLink]="[]" class="link-active" (click)="navigateToItem()">{{'itemDetails.nav1' | translate}}</a> /
              <!-- <span class="nav-link">{{currentTab}}</span> -->
              <span class="nav-link" *ngIf="tab1">{{currentTab}}</span>
              <span class="nav-link" *ngIf="!tab1">{{'itemDetails.nav2' | translate}}</span>
              <!-- <span class="nav-link">{{'itemDetails.nav2' | translate}}</span> -->
            </div>
          </div>
        </div>
        <div class="item-info-container">
          <div class="itemdetail">
            <div class="item-name"><span>{{'itemDetails.labelName' | translate}}: {{itemBankNameDisplay}}</span>
            </div>
            <div class="item-desc"><span>{{'itemDetails.labelDesc' | translate}}: {{itemBankNameDescription}}</span></div>
          </div>
          <span class="spacer"></span>
          <div class="edit-btn-wrapper">
            <span class="item-active">
              <i-feather name="disc"></i-feather>
              <span>{{itemStatus}}</span>
            </span>
            <div class="btn-wrapper">
              <button mat-icon-button aria-label="Edit Item" matTooltip="{{'itemDetails.edit' | translate}}"
                [disabled]="itemStatusId !== itemStatusList[1]?.itemStatusId || (roleSer.accessData?!roleSer.accessData.insertAllowed || !roleSer.accessData.updateAllowed :true)"
                matTooltipPosition="above" (click)="openNewItemDialog()" class="edit"><span class="menu-icon">
                  <i-feather name="edit"></i-feather>
                </span></button>
            </div>
          </div>
        </div>
        <div class="tab-container">
          <mat-tab-group mat-align-tabs="end" animationDuration="0ms">        <!--(selectedTabChange)="onChangeTab($event)" [selectedIndex]="selectedTabIndex"-->
            <mat-tab label="{{'itemDetails.tab1' | translate}}">
              <ng-template mat-tab-label>
                <span class="menu-icon">
                  <i-feather name="help-circle"></i-feather>
                </span>
                <span>{{'itemDetails.TabQuestions.title' | translate}} ({{numberOfQuestions}})</span>
              </ng-template>
              <div class="tab-content">  <!--*ngIf="selectedTabIndex === 0"-->
                <app-question-list-details [itemDetails]="data" (numberOfQuestion)="getQuestionCount($event)"></app-question-list-details>
              </div>
            </mat-tab>
            <mat-tab label="{{'itemDetails.tab2' | translate}}">
              <ng-template mat-tab-label>
                <span class="menu-icon">
                  <i-feather name="tag"></i-feather>
                </span>
                <span>{{'itemDetails.TabTags.title' | translate}}</span>
              </ng-template>
              <div class="tab-content">   <!--*ngIf="selectedTabIndex === 1"-->
                <app-item-tags [isPublished]='isPublished' [item]='data'></app-item-tags>
              </div>
            </mat-tab>

            <mat-tab label="{{'itemDetails.tab3' | translate}}">
              <ng-template mat-tab-label>
                <span class="menu-icon"> <i-feather name="settings"></i-feather> </span> <span>{{'itemDetails.TabSettings.title' | translate}}</span>
              </ng-template>
              <div class="tab-content"> <!--*ngIf="selectedTabIndex === 2"-->

                <app-item-settings [isPublished]='isPublished' [itemId]='itemId' [testId]="testId">
                </app-item-settings>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
